import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { EditTemplateSpotlightMenuViewModel } from '../edit-template-spotlight-menu-view-model';
import { ViewModelConnector } from '@mobilefirstdev/base-angular';

@Component({
  selector: 'app-edit-template-spotlight-menu-footer',
  templateUrl: './edit-template-spotlight-menu-footer.component.html',
  styleUrls: [
    './edit-template-spotlight-menu-footer.component.scss',
    '../../../../../shared/styles/edit-page-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTemplateSpotlightMenuFooterComponent extends BaseComponent {
  constructor(public viewModel: EditTemplateSpotlightMenuViewModel) {
    super();
  }

  @Input() formDisableSubmit: boolean = true;
  @Input() formErrorMessages: { [label: string]: string } | null | undefined;
  @Input() formHasErrors: boolean = true;
  @Input() formPristine: boolean = true;
  @Input() @ViewModelConnector('connectToFormAutoSubmitted') formAutoSubmitted: any[];
  @Output() submitForms = new EventEmitter<boolean>(true);
}
